var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5006 6.50708C23.3647 6.02231 23.1 5.58342 22.7346 5.23708C22.3589 4.88008 21.8984 4.62471 21.3966 4.49508C19.5186 4.00008 11.9946 4.00008 11.9946 4.00008C8.85795 3.96439 5.72205 4.12135 2.60462 4.47008C2.10281 4.60929 1.64318 4.87036 1.26662 5.23008C0.896617 5.58608 0.628617 6.02508 0.488617 6.50608C0.15231 8.31782 -0.0110908 10.1574 0.000617183 12.0001C-0.0113828 13.8411 0.151617 15.6801 0.488617 17.4941C0.625617 17.9731 0.892617 18.4101 1.26362 18.7631C1.63462 19.1161 2.09662 19.3711 2.60462 19.5061C4.50762 20.0001 11.9946 20.0001 11.9946 20.0001C15.1353 20.0358 18.2752 19.8789 21.3966 19.5301C21.8984 19.4004 22.3589 19.1451 22.7346 18.7881C23.0999 18.4418 23.3643 18.0029 23.4996 17.5181C23.8447 15.707 24.0125 13.8667 24.0006 12.0231C24.0266 10.1717 23.859 8.32264 23.5006 6.50608V6.50708ZM9.60262 15.4241V8.57708L15.8626 12.0011L9.60262 15.4241Z",
    fill: "#9CA0A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.193d9963d23fcc1b6af1c485a758a2d2.svg";
export { ForwardRef as ReactComponent };